"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _curriculum = _interopRequireDefault(require("./curriculum.png"));
var _Mediator = _interopRequireDefault(require("./Mediator"));
var _Settings = _interopRequireDefault(require("./Settings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
 * WARNING: DO NOT MOVE THIS FILE
 *
 * Its location is referenced directly from within an app because the search
 * for navigations occurs BEFORE the export in Root.js.
 *
 * To use this mediator in your app, import as follows:
 *
 * import curriculum from 'cccisd-laravel-assignment/dist/components/navigations/curriculum';
 */
var _default = exports["default"] = {
  handle: 'curriculum',
  label: 'Curriculum',
  thumbnail: _curriculum["default"],
  mediatorComponent: _Mediator["default"],
  settingsComponent: _Settings["default"]
};